import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Paper,
  Rating,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useCallback, useEffect, useRef, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddTestimonialModal from "../components/AddTestimonialModal";
import ReactQuill from "react-quill";

const TestimonialAccordian = (props) => {
  const { title, data, setData } = props;
  const prevProps = useRef();
  const [selectedTestimonial, selectTestimonial] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    setTestimonials(data?.testimonials);
  }, [data?.testimonials]);

  useEffect(() => {
    if (JSON.stringify(testimonials) !== prevProps?.current?.prevTestimonials) {
      setData((preState) => ({ ...preState, testimonials }));
    }

    return () => {
      prevProps.current = {
        prevTestimonials: JSON.stringify(testimonials),
      };
    };
  }, [testimonials]);

  const handleModal = useCallback((show = false, selectedObj) => {
    show = typeof show === "boolean" && show;
    setShowModal(show);
    selectTestimonial(selectedObj);
  }, []);

  const handleTestimonial = useCallback((showroomObj) => {
    let { index, ...rest } = showroomObj;

    if (index !== undefined) {
      setTestimonials((preState) =>
        preState.map((obj, i) => (i === index ? rest : obj))
      );
    } else {
      setTestimonials((preState) => [...preState, showroomObj]);
    }
  }, []);

  const handleRemove = useCallback((index) => {
    setTestimonials((preState) => preState.filter((_, i) => i !== index));
  }, []);

  const handleChange = useCallback(
    (name) => (e) => {
      let value = e?.target?.value ?? e?.target?.checked ?? e;

      setData((preState) => ({ ...preState, [name]: value }));
    },
    [setData]
  );

  return (
    <>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography fontWeight={"600"}>{title}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <div className="form_comp">
            <label htmlFor="title">Title</label>
            <ReactQuill
              placeholder="Enter title"
              value={data?.title}
              onChange={handleChange("title")}
              theme="snow"
              className="edit_container"
              bounds={`[data-text-editor="name"]`}
            />
          </div>
          <div className="form_comp">
            <label htmlFor="title">Description</label>
            <ReactQuill
              placeholder="Enter description"
              value={data?.description}
              onChange={handleChange("description")}
              theme="snow"
              className="edit_container"
              bounds={`[data-text-editor="name"]`}
            />
          </div>
          <div className="btn-container mt15">
            <Button
              variant="contained"
              className="bordered-button float-right"
              onClick={() => handleModal(true)}
            >
              + Add Testimonial
            </Button>
          </div>

          <TableContainer component={Paper} sx={{ mt: 2 }}>
            <Table sx={{ minWidth: 650, px: 2 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{ fontWeight: 700 }}
                    align="left"
                    className="tablecell"
                  >
                    Name
                  </TableCell>
                  <TableCell
                    style={{ fontWeight: 700 }}
                    align="left"
                    className="tablecell"
                  >
                    Description
                  </TableCell>
                  <TableCell
                    style={{ fontWeight: 700 }}
                    align="left"
                    className="tablecell"
                  >
                    Rating
                  </TableCell>
                  <TableCell
                    style={{ fontWeight: 700 }}
                    align="left"
                    className="tablecell"
                  >
                    Edit
                  </TableCell>
                  <TableCell
                    style={{ fontWeight: 700 }}
                    align="left"
                    className="tablecell"
                  >
                    Delete
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {testimonials?.map((testimonial, index) => {
                  return (
                    <TableRow
                      key={testimonial?.name}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell align="left" component="th" scope="row">
                        <Box className="origin_des">
                          <Box>
                            <Typography
                              style={{
                                maxWidth: 200,
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                              }}
                              className="font600 fs_14"
                            >
                              {testimonial?.name}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell align="left" component="th" scope="row">
                        <Box className="origin_des">
                          <Box
                            sx={{
                              ml: 3,
                            }}
                          >
                            <Typography
                              style={{
                                maxWidth: 400,
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                              }}
                              className="font600 fs_14"
                            >
                              {testimonial?.description}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell align="left" component="th" scope="row">
                        <Box className="origin_des">
                          <Rating
                            style={{ width: "max-content" }}
                            name="simple-controlled"
                            value={testimonial.rating}
                            disabled
                          />
                        </Box>
                      </TableCell>

                      <TableCell
                        align="left"
                        onClick={() =>
                          handleModal(true, {
                            ...testimonial,
                            index,
                          })
                        }
                      >
                        <EditIcon />
                      </TableCell>
                      <TableCell
                        align="left"
                        onClick={() => handleRemove(index)}
                      >
                        <DeleteIcon />
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </AccordionDetails>
      </Accordion>
      <AddTestimonialModal
        open={showModal}
        handleClose={() => setShowModal(false)}
        selectedTestimonial={selectedTestimonial}
        handleTestimonial={handleTestimonial}
      />
    </>
  );
};

export default TestimonialAccordian;
